import { FileEarmarkPpt, FileEarmarkWord, FileEarmarkImage, FileEarmarkPdf, FileEarmarkMusic, FileEarmarkPlay, FileEarmarkExcel, FileEarmarkZip } from 'react-bootstrap-icons';

// 专家级别
export const expertLevels = [
    { level: 6, label: '医院VIP★★★★★', desc: '政府正副部级、部级领导（含已退）。' },
    { level: 5, label: '医院VIP★★★★', desc: '政府正副司局级领导、正副厅级领导；院士；国家级重要学协会会长、驻会副会长、秘书长；TOP20医院院长、书记。' },
    { level: 4, label: '医院VIP★★★', desc: '政府正副处级、正副科级领导；国家级学协会副会长、秘书长；TOP21-50医院院长、书记；知名高校校长、医学院院长。' },
    { level: 3, label: '医院VIP★★', desc: 'TOP100医院正副书记、院长；国家级专委会主委、分会会长；普通高校校长、研究院院长或所长；合作医院院长、书记。' },
    { level: 2, label: '医院VIP★', desc: '政府、国家级学会工作人员；合作医院副院长、副书记、科室主任；省级重要学协会分会/专委会副主任委员；三甲医院院级管理者。' },
    { level: 1, label: '医院VIP', desc: '除以上条件外的医疗决策人。' },
    { level: 9, label: '医院人员', desc: '非医疗决策人的医院人员。' },
    { level: 24, label: '企业VIP★★★', desc: '百亿级公司VP及以上' },
    { level: 23, label: '企业VIP★★', desc: '十亿级公司VP及以上 + 百亿级公司中层' },
    { level: 22, label: '企业VIP★', desc: '亿级公司VP及以上 + 十亿级公司中层' },
    { level: 21, label: '企业VIP', desc: '亿级以下合作企业中层' }, // 原 level 10
    { level: 11, label: '企业人员', desc: '除以上条件外的企业人员' },
    { level: 12, label: '健康界工作人员' },
    { level: 0, label: '普通用户' },
];

// 会议嘉宾身份：1参会嘉宾，2参会代表，3企业人员，4工作人员，0待定
export const ConferenceGuestRoles = [
    { value: 1, label: '参会嘉宾' },
    { value: 2, label: '参会代表' },
    { value: 3, label: '企业人员' },
    { value: 4, label: '工作人员' },
    { value: 0, label: '待定' },
];

// 邀请函项目类型 application_type
// 1医会议，2医评议
export const invitationApplicationTypes = [
    { type: 1, name: '医会议' },
    { type: 2, name: '医评议' },
];

// 邀请函用户称呼
// 用户称呼1=无,2=先生/女士,3=教授,4=嘉宾,5=老师,6=专家职务
export const invitationNameTitles = [
    { type: 1, title: '' },
    { type: 2, title: '先生/女士' },
    { type: 3, title: '教授' },
    { type: 4, title: '嘉宾' },
    { type: 5, title: '老师' },
    { type: 6, title: '专家职务' },
];

// 劳务付费类型
export const laborFeePaymentMethods = [
    { value: 1, label: '银行转账' },
    { value: 2, label: '现金支付' },
    { value: 3, label: '无需支付' },
];

// 银行转账-劳务费支付主体
export const laborFeeCostBearers = [
    { value: 1, label: '华媒康讯' },
    { value: 2, label: '博鳌研究院' },
    { value: 3, label: '尚医文化' },
    { value: 4, label: '尚医咨询' },
    { value: 5, label: '健康界科技' },
    { value: 6, label: '上海分公司' },
    { value: 0, label: '其他' },
];

// 第三方平台付款-劳务费支付主体
export const laborFee3rdPartyPaymentMethods = [{ value: 101, label: '福建万古科技发展有限公司' }];

// 认证职称列表（医疗决策人 Medical decision-maker, mdm）
const authPositions = [
    { code: 'A01-ZHW-B02', name: '党委书记', mdm: 1 },
    { code: 'A01-ZHW-B08', name: '党委副书记', mdm: 1 },
    { code: 'A01-ZHW-B01', name: '院长', mdm: 1 },
    { code: 'A01-ZHW-B09', name: '副院长', mdm: 1 },
    { code: 'A01-ZHW-B10', name: '院长助理', mdm: 1 },
    { code: 'A01-ZHW-B11', name: '纪委书记', mdm: 1 },
    { code: 'A01-ZHW-B12', name: '纪委副书记', mdm: 1 },
    { code: 'A01-ZHW-B13', name: '总会计师', mdm: 1 },
    { code: 'A01-ZHW-B14', name: '工会主席', mdm: 1 },
    { code: 'A01-ZHW-B15', name: '其他院级领导', mdm: 1 },
    { code: 'A01-ZHW-B03', name: '主任', mdm: 1 },
    { code: 'A01-ZHW-B16', name: '副主任', mdm: 1 },
    { code: 'A01-ZHW-B04', name: '部长', mdm: 1 },
    { code: 'A01-ZHW-B17', name: '副部长', mdm: 1 },
    { code: 'A01-ZHW-B05', name: '科长', mdm: 1 },
    { code: 'A01-ZHW-B18', name: '副科长', mdm: 1 },
    { code: 'A01-ZHW-B06', name: '处长', mdm: 1 },
    { code: 'A01-ZHW-B19', name: '副处长', mdm: 1 },
    { code: 'A01-ZHW-B20', name: '护士长', mdm: 1 },
    { code: 'A01-ZHW-B21', name: '副护士长', mdm: 1 },
    { code: 'A01-ZHW-B22', name: '其他中层领导', mdm: 1 },
    { code: 'A01-ZHW-B23', name: '科内组长/副组长' },
    { code: 'A01-ZHW-B07', name: '无领导职务' },
];

// 证件类型
export const cardTypes = [
    { code: 1, name: '身份证号码' },
    { code: 2, name: '港澳居民来往内地通行证' },
    { code: 3, name: '台湾居民来往大陆通行证' },
    { code: 4, name: '外国人永久居留身份证' },
    { code: 5, name: '护照' },
];

// 评分赛段任务类型 - 选手
export const playerStageTaskTypes = [
    { key: 'PLAYER_UPLOAD_JOIN_FILE', label: '上传评议材料' },
    { key: 'PLAYER_FILL_TEAM_INFO', label: '填写阶段参与人' },
    // { key: "PLAYER_VIEW_SCORE_LIST", label: "查看评分榜单" },
    { key: 'PLAYER_VIEW_SCORE_REPORT', label: '查看评议报告' },
    { key: 'PLAYER_GET_AWARD_CERTIFICATE', label: '领取结果证书' },
    { key: 'TASK_LINK', label: '跳转链接' },
    { key: 'TASK_DOCUMENT', label: '文档' },
    { key: 'TASK_TEXT', label: '文本' },
    { key: 'FILL_APPLICANT', label: '门票申领' },
];

// 评分赛段任务类型 - 评委
export const judgeStageTaskTypes = [
    { key: 'JUDGE_CASE_SCORE', label: '实践评议' },
    // { key: "JUDGE_VIEW_COMMENT", label: "查看点评" },
    // { key: "JUDGE_VIEW_SCORE_LIST", label: "查看榜单" },
    { key: 'JUDGE_GET_APPOINTMENT_LETTER', label: '领取专家聘书' },
    { key: 'TASK_LINK', label: '跳转链接' },
    { key: 'TASK_DOCUMENT', label: '文档' },
    { key: 'TASK_TEXT', label: '文本' },
];

// 文件类型（带图标）
export const FileTypeWithIconList = [
    { ext: /^pptx?$/i, icon: <FileEarmarkPpt color="#F58A33" /> },
    { ext: /^docx?$/i, icon: <FileEarmarkWord color="#487EFF" /> },
    { ext: /^xlsx?$/i, icon: <FileEarmarkExcel color="#408558" /> },
    { ext: /^png|jpe?g$/i, icon: <FileEarmarkImage color="#569C39" /> },
    { ext: /^pdf$/i, icon: <FileEarmarkPdf color="#F58A33" /> },
    { ext: /^zip|rar$/i, icon: <FileEarmarkZip color="#C18A20" /> },
    { ext: /^mp3$/i, icon: <FileEarmarkMusic color="#33AF8C" /> },
    { ext: /^mp4|rmvb|rm$/i, icon: <FileEarmarkPlay color="#487EFF" /> },
];

/**
 * @description: 机构库相关数据
 */

// 机构类型
export const orgTypeList = [
    { value: 1, label: '医疗机构' },
    { value: 2, label: '政府机构' },
    { value: 3, label: '学协会' },
    { value: 4, label: '科研院校' },
    { value: 5, label: '企业' },
    { value: 0, label: '未分类' },
];

// 医院机构类型
export const medTypeList = ['综合医院', '专科医院', '中医医院', '中西医结合医院', '中医专科医院', '民族医院', '妇幼保健院', '基层医疗卫生机构', '其他'];

// 医院机构性质
export const medOwnershipList = ['公立医院', '国企办医', '民营医院', '外资医院'];

// 医院机构层级
export const medTierList = ['委属委管', '省级医院', '地市级医院', '县区级医院'];

// 等级
export const medLevelList = ['三级', '二级', '一级', '未定级', '未知'];

// 等次
export const medGradeList = ['甲等', '乙等', '丙等', '未定等', '未知'];

// 会议执行类型
export const conferenceTypes = [
    { label: '线上', type: 1 },
    { label: '线下', type: 2 },
    { label: '线上+线下', type: 3 },
];

// 专家评分对应文案
export const starTexts = ['未达预期', '一般', '不错', '满意', '惊喜'];

// 机构管理 - 领导班子
// code 即 职务字典 code（memPostCode）
// sort 按 党委书记 > 院长 > 党委副书记 > 纪委书记 > 纪委副书记 > 党委委员 > 副院长 > 总会计师 > 工会主席 > 院长助理 排序
export const orgLeaders = [
    // 党组织领导
    { code: 'A01-ZHW-B02', name: '党委书记', sort: 1 },
    { code: 'A01-ZHW-B08', name: '党委副书记', sort: 3 },
    { code: 'A01-ZHW-B11', name: '纪委书记', sort: 4 },
    { code: 'A01-ZHW-B12', name: '纪委副书记', sort: 5 },
    { code: 'A01-ZHW-B24', name: '党委委员', sort: 6 },
    // 行政领导
    { code: 'A01-ZHW-B01', name: '院长', sort: 2 },
    { code: 'A01-ZHW-B09', name: '副院长', sort: 7 },
    { code: 'A01-ZHW-B13', name: '总会计师', sort: 8 },
    { code: 'A01-ZHW-B14', name: '工会主席', sort: 9 },
    { code: 'A01-ZHW-B10', name: '院长助理', sort: 10 },
];

// 可信度
export const credibilityList = [
    {
        value: 'high',
        label: '高可信',
        icon: 'bi-patch-check',
        color: '#52c41a',
        tooltip: '近2年内有真实劳务费支付记录（信息完整且已完成支付）',
    },
    {
        value: 'medium',
        label: '中可信',
        icon: 'bi-patch-check',
        color: '#1890ff',
        tooltip: (
            <span>
                满足以下任一条件：
                <br />• 近1年内本人完成个人专业认证，或本人更新专业认证信息
                <br />• 近1年内本人有参与项目行为（如签到、确认实际日程、评议等）
                <br />• 最近一次劳务费支付时间在2年时间以上但在3年内
            </span>
        ),
    },
    {
        value: 'low',
        label: '低可信',
        icon: 'bi-patch-question',
        color: '#8c8c8c',
        tooltip: '不满足以上条件的其他专家',
    },
];

// 专家 荣誉头衔
export const honoraryList = [
    '享受国务院特殊津贴专家',
    '中国科学院院士',
    '中国工程院院士',
    '“长江学者”特聘教授',
    '“长江学者”讲座教授',
    '青年长江学者',
    '国家杰青',
    '国家优青',
    '海外优青',
    '国家“万人计划”杰出人才',
    '国家“万人计划”领军人才',
    '国家“万人计划”青年拔尖人才',
    '省级“万人计划”杰出人才',
    '省级领军人才',
    '国家“百千万”人才',
    '省级“百千万”人才',
    '国家有突出贡献中青年专家',
    '省级有突出贡献中青年专家',
    '市级有突出贡献中青年专家',
    '岐黄学者',
    '“泰山学者”特聘专家',
    '“泰山学者”青年专家',
    '北京学者',
    '“珠江学者”特聘教授',
    '“珠江学者”青年学者',
    '海河学者',
    '上海工匠',
    '上海医务工匠',
    '上海市领军人才',
    '上海市优秀学科带头人',
    '上海市优秀学术带头人',
    '中原学者',
    '钱江学者',
    '天府学者',
    '巴渝学者',
    '芙蓉学者',
    '八桂学者',
    '长白山学者',
    '天山学者',
    '燕赵学者',
    '三晋学者',
    '龙江学者',
    '云岭学者',
    '“何梁何利奖”获得者',
    '“吴杨奖”获得者',
    '“吴阶平医学奖”获得者',
    '“中国医师奖”获得者',
    '“白求恩奖章”获得者',
    '“国家科技进步一等奖”获得者',
    '“国家科技进步二等奖”获得者',
    '“全国创新争先奖状”获得者',
    '“国家自然科学奖一等奖”获得者',
    '“国家自然科学奖二等奖”获得者',
    '全国先进工作者',
    '省级先进工作者',
    '全国三八红旗手',
    '省级三八红旗手',
    '全国“五一劳动奖章”获得者',
    '省级“五一劳动奖章”获得者',
    '全国优秀教育工作者',
    '省级优秀教育工作者',
    '中国好医生',
    '中国好护士',
    '国家杰出医师',
    '全球前2%顶尖科学家',
    '全国优秀医院院长',
];

// 认证身份类型
// （个人）职务认证
// 认证单位类型 1医疗从业者 2政府官员 3社会团体 4教育科研 5商业人士
// 1. 所有类型都有 ZHW 字段
// 2. A01 和 A04 有职称
// 3. 只有 A01 有科室
// 其中的 orgType 为创建个人单位时的单位类型，区别于机构认证中的 authType
export const identityTypes = [
    {
        code: 'A01',
        label: '医疗机构从业者',
        name: 'MedicalStaff',
        orgType: 1,
        desc: '如临床、医技、职能科室人员及管理者',
    }, // 有 KSH, ZHW, ZHCH
    {
        code: 'A06',
        label: '社会团体人士',
        name: 'SocialGroupStaff',
        orgType: 3,
        desc: '如学/协会工作者',
    }, // 有 ZHW
    {
        code: 'A02',
        label: '政府官员',
        name: 'GovOfficial',
        orgType: 2,
        desc: '如卫健、医保、药监系统政务人士',
    }, // 有 ZHW
    {
        code: 'A04',
        label: '教育科研人士',
        name: 'EduResearchers',
        orgType: 4,
        desc: '如科研机构工作者、大学教职工及学生',
    }, // 有 ZHW, ZHCH
    {
        code: 'A03',
        label: '商业人士',
        name: 'BizPeople',
        orgType: 5,
        desc: '如企业人员',
    }, // 有 ZHW
];

// 机构认证类型（平台侧 memType===2 时 memberInfo.orgType；区别于上方 identityTypes 内的个人单位 orgType）
export const orgAuthTypes = [
    { orgAuthType: 0, label: '企业' },
    { orgAuthType: 1, label: '媒体' },
    { orgAuthType: 2, label: '医疗机构' },
    { orgAuthType: 3, label: '机构' },
];

// 项目负责人
export const ProjectManagers = [
    { admin_id: 69, name: '陈晓月', phone: '18610612460' },
    { admin_id: 56, name: '王新桐', phone: '15201374989' },
    { admin_id: 77, name: '孙浩', phone: '13552898812' },
    { admin_id: 66, name: '曹霞', phone: '18611121206' },
    { admin_id: 233, name: '明延飞', phone: '18099830870' },
    { admin_id: 92, name: '闫荣伟', phone: '13601325564' },
    { admin_id: 47, name: '张燕敏', phone: '18210928954' },
    { admin_id: 264, name: '郭思明', phone: '15510610285' },
    { admin_id: 54, name: '黄韦乔', phone: '18612015770' },
    { admin_id: 266, name: '张金萍', phone: '18911301370' },
    { admin_id: 131, name: '孙琦', phone: '13051319050' },
    { admin_id: 248, name: '李尧', phone: '13021283499' },
    { admin_id: 141, name: '赵静', phone: '15210260179' },
    { admin_id: 269, name: '路芳芳', phone: '18375339991' },
    { admin_id: 270, name: '刘爽', phone: '15810555869' },
    { admin_id: 271, name: '王懿晗', phone: '18811380380' },
    { admin_id: 255, name: '孙琪', phone: '17743547967' },
    { admin_id: 128, name: '王宇', phone: '13699228825' },
    { admin_id: 129, name: '秦凤艳', phone: '18932866653' },
    { admin_id: 170, name: '梁雅雯', phone: '18810543990' },
    { admin_id: 165, name: '苗萌', phone: '15810219464' },
    { admin_id: 169, name: '李子君', phone: '13693680128' },
    { admin_id: 97, name: '郑宇钧', phone: '15110104979' },
    { admin_id: 268, name: '李一平', phone: '15601229611' },
    { admin_id: 49, name: '何小雨', phone: '13131315454' },
    { admin_id: 236, name: '林畅', phone: '15901382033' },
    { admin_id: 139, name: '葛崇阳', phone: '18621048330' },
    { admin_id: 138, name: '李双阳', phone: '13636610808' },
    { admin_id: 137, name: '陈雷', phone: '13795208351' },
    { admin_id: 197, name: '韩言', phone: '15231580454' },
    { admin_id: 48, name: '王娜', phone: '18612353192' },
    { admin_id: 274, name: '王浩', phone: '18811157952' },
    { admin_id: 272, name: '任帅', phone: '17835697017' },
    { admin_id: 288, name: '李欢', phone: '18228259852' },
];

// 部门负责人
export const DepartmentManagers = [
    { admin_id: 69, name: '陈晓月', phone: '18610612460' },
    { admin_id: 56, name: '王新桐', phone: '15201374989' },
    { admin_id: 77, name: '孙浩', phone: '13552898812' },
    { admin_id: 66, name: '曹霞', phone: '18611121206' },
    { admin_id: 233, name: '明延飞', phone: '18099830870' },
    { admin_id: 92, name: '闫荣伟', phone: '13601325564' },
    { admin_id: 47, name: '张燕敏', phone: '18210928954' },
    { admin_id: 264, name: '郭思明', phone: '15510610285' },
    { admin_id: 54, name: '黄韦乔', phone: '18612015770' },
    { admin_id: 266, name: '张金萍', phone: '18911301370' },
    { admin_id: 128, name: '王宇', phone: '13699228825' },
    { admin_id: 141, name: '赵静', phone: '15210260179' },
    { admin_id: 139, name: '葛崇阳', phone: '18621048330' },
];

// 分管高管
export const SeniorManagers = [
    { admin_id: 28, name: '赵红', phone: '13701184429' },
    { admin_id: 48, name: '王娜', phone: '18612353192' },
    { admin_id: 135, name: '董岩', phone: '18601197112' },
    { admin_id: 69, name: '陈晓月', phone: '18610612460' },
    { admin_id: 54, name: '黄韦乔', phone: '18612015770' },
];

// 总裁
export const bossName = '赵红';

// 财务经理
export const FinanceManager = {
    admin_id: 176,
    name: '赵玲',
    phone: '15010291280',
};

// 财务总监
export const FinanceSeniorManager = {
    admin_id: 157,
    name: '赵鹏',
    phone: '13810933931',
};

// 劳务费流程节点 process nodes
// 1 经办人发起
// 2 部门负责人审核
// 11 项目负责人审核
// 3 分管高管审批
// 4 总裁审批
// 5 财务经理审核
// 6 财务总监审批
// 10 出纳付款
export const laborFeeProcessNodes = [
    { nodeId: 1, name: '经办人发起' },
    { nodeId: 2, name: '部门负责人审核' },
    { nodeId: 11, name: '项目负责人审核' },
    { nodeId: 3, name: '分管高管审批' },
    { nodeId: 4, name: '总裁审批' },
    { nodeId: 5, name: '财务经理审核' },
    { nodeId: 6, name: '财务总监审批' },
    { nodeId: 10, name: '出纳付款' },
];

// 币种
// currency 货币代码
// name 货币名称
// majorUnit 主币单位
// minorUnits 辅币单位
export const CurrencyList = [
    { currency: 'CNY', name: '人民币', majorUnit: '元', minorUnits: ['角', '分'] },
    { currency: 'USD', name: '美元', majorUnit: '元', minorUnits: ['分'] },
    { currency: 'HKD', name: '港币', majorUnit: '元', minorUnits: ['角', '分'] },
    { currency: 'JPY', name: '日元', majorUnit: '元', minorUnits: [] }, // 日元没有辅币单位
    { currency: 'EUR', name: '欧元', majorUnit: '元', minorUnits: ['分'] },
    { currency: 'GBP', name: '英镑', majorUnit: '镑', minorUnits: ['便士'] },
    { currency: 'CHF', name: '瑞士法郎', majorUnit: '法郎', minorUnits: ['分'] },
    { currency: 'CAD', name: '加拿大元', majorUnit: '元', minorUnits: ['分'] },
    { currency: 'SGD', name: '新加坡元', majorUnit: '元', minorUnits: ['分'] },
    { currency: 'TWD', name: '新台币', majorUnit: '元', minorUnits: ['角', '分'] },
    { currency: 'THB', name: '泰铢', majorUnit: '铢', minorUnits: ['萨当'] },
];
